import {
  ref,
  shallowRef,
  provide,
  watch,
  onMounted,
  nextTick,
  watchEffect,
  onBeforeUnmount
} from '@vue/composition-api'
import { on, off } from '@/util'
import { throttle } from 'lodash-es'
export const useTable = (props, tableRef, renderColumns) => {
  // 表格就凑程度
  const tableSize = ref(props.size.value || 'medium')
  // 表格是否有边框
  const tableBorder = ref(props.border.value)
  const tableScrollEl = shallowRef(null)
  const tableHeaderScrollEl = shallowRef(null)
  const tableWidth = ref(0)
  const scrollLeft = ref(0)

  // 表格在x轴、y轴滚动
  const tableScroll = ref({})
  const setScrollLeft = (value) => {
    scrollLeft.value = value
  }
  const initScroll = () => {
    if (props.scroll.value.y) {
      tableScroll.value.height = props.scroll.value.y
    }
  }
  const setTableSize = (size) => {
    tableSize.value = size
  }
  const setTableBorder = () => {
    tableBorder.value = !tableBorder.value
  }

  const getScrollEl = (className) => {
    if (tableRef.value) {
      return tableRef.value.$el.querySelector(className)
    }
    return null
  }
  watchEffect(() => {
    if (tableScrollEl.value) {
      tableScrollEl.value.scroll({ top: 0, left: scrollLeft.value || 0 })
    }
  })
  const setWidth = () => {
    const time = setTimeout(() => {
      if (tableScrollEl.value) {
        tableWidth.value = tableScrollEl.value.scrollWidth
        setScrollLeft(tableScrollEl.value.scrollLeft)
      }
      clearTimeout(time)
    }, 100)
  }

  const setScroll = throttle((e) => {
    setScrollLeft(e.target.scrollLeft)
  }, 100)
  watch(
    renderColumns,
    () => {
      setWidth()
    },
    { deep: true }
  )
  onMounted(() => {
    nextTick(() => {
      const time = setTimeout(() => {
        tableScrollEl.value = getScrollEl('.el-table__body-wrapper')
        tableHeaderScrollEl.value = getScrollEl('.el-table__header-wrapper')
        clearTimeout(time)
        setWidth()
        on(window, 'resize', throttle(setWidth, 100))
        on(tableScrollEl.value, 'scroll', setScroll)
      }, 900)
    })
  })
  onBeforeUnmount(() => {
    off(window, 'resize', throttle(setWidth, 100))
    off(tableScrollEl.value, 'scroll', setScroll)
  })
  watch(() => props.scroll, initScroll, { immediate: true, deep: true })

  const all = {
    tableSize,
    setTableSize,

    tableBorder,
    setTableBorder,
    tableWidth,
    scrollLeft,
    setScrollLeft,
    tableScrollEl
  }
  provide('tableInfo', {
    setTableSize,
    setTableBorder,
    setScrollLeft
  })

  return all
}
